import { render, staticRenderFns } from "./QuestionTypes.vue?vue&type=template&id=f2145d82&scoped=true&lang=pug&"
import script from "./QuestionTypes.vue?vue&type=script&lang=js&"
export * from "./QuestionTypes.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTypes.vue?vue&type=style&index=0&id=f2145d82&scoped=true&lang=css&"
import style1 from "./QuestionTypes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2145d82",
  null
  
)

export default component.exports